<div class="form-group mt-3 fill-dark-blue">Referrals converted (last 6 months)</div>
<ng-table [rows]="rows" [columns]="columns"></ng-table>